export const sentenceGenerationForMultiSelect = (labels: string[]): string => {
  const maxLength = 28
  let result = ''
  let remaining = 0

  for (let i = 0; i < labels.length; i++) {
    // Check if adding the next string would exceed the limit
    if (result.length <= maxLength) {
      if (result.length > 0) {
        result += ', '
      }
      result += labels[i]
    } else {
      remaining = labels.length - i
      break
    }
  }

  if (result.length > maxLength) {
    result = result.substring(0, maxLength)
    result += remaining > 0 ? `..+${remaining}` : '..'
  }

  return result
}
